import { render } from "./chevron-down.svg?vue&type=template&id=cbba5490"
const script = {}
script.render = render

export default script